/** `NEXT_PUBLIC_BUILD_DATE`(UTC ISO) → KST(GMT+9) 짧은 표시. 없거나 파싱 불가면 빈 문자열. */
export function formatBuildDateLabel(): string {
  const raw = process.env.NEXT_PUBLIC_BUILD_DATE;
  if (!raw) return "";
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return "";
  const tz = "Asia/Seoul";
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: tz,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(d);
  const v = (type: Intl.DateTimeFormatPart["type"]) =>
    parts.find((x) => x.type === type)?.value ?? "";
  const y = v("year");
  const m = v("month");
  const day = v("day");
  const h = v("hour");
  const min = v("minute");
  if (!y || !m || !day || !h || !min) return "";
  return `${y}-${m}-${day} ${h}:${min} KST`;
}
